module.exports = __webpack_public_path__ + "static/media/banner@768.90f17d12.png";